import React from "react";
import Navigator from "../../../components/navigator/Navigator";

export const ConversationsSection = ({ id }: { id: string }) => {
    return (
        <>
            Soon...
        </>
    );
}